'use client'

import React from 'react'

import { ColorScheme } from '../../types'
import { AddIcon } from '../Icon/AddIcon'
import { IconButton } from './IconButton'

export type AddButtonProps = {
  colorScheme?: ColorScheme
  onClick?: () => void
  bgColor?: string
  hoverBgColor?: string
  textColor?: string
  disabled?: boolean
}

export const AddButton = (props: AddButtonProps) => (
  <IconButton aria-label='Add label' icon={<AddIcon size={10} />} {...props} />
)
